import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Textarea,
} from "@bookdental/ui";
import { trpc } from "@/lib/trpc";
import { AJUDA_PROTESE } from "@/lib/ajuda/dialogos/protese";
import type { ProsthesisLabRow } from "./types";

type Props = {
  lab: ProsthesisLabRow | null;
  onClose: () => void;
};

/** Compõe e envia uma mensagem direto pro e-mail cadastrado do parceiro (fila de email real). */
export function ProsthesisLabMessageDialog({ lab, onClose }: Props) {
  const open = !!lab;
  const [message, setMessage] = useState("");

  const sendMessage = trpc.prosthesis.lab.sendMessage.useMutation({
    onSuccess: () => {
      toast.success(`Mensagem enviada para ${lab?.name}`);
      setMessage("");
      onClose();
    },
    onError: (err) => toast.error(err.message || "Falha ao enviar mensagem"),
  });

  const handleClose = () => {
    setMessage("");
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent className="max-w-md dark:border-border dark:bg-card">
        <DialogHeader>
          <DialogTitle className="dark:text-foreground" ajuda={AJUDA_PROTESE.emailParaLaboratorio}>
            Enviar e-mail para {lab?.name}
          </DialogTitle>
          <DialogDescription className="dark:text-muted-foreground">
            A mensagem é enviada direto para {lab?.email}.
          </DialogDescription>
        </DialogHeader>

        <Textarea
          autoFocus
          rows={6}
          placeholder="Escreva sua mensagem..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className="dark:border-border dark:bg-background/50 dark:text-foreground"
        />

        <DialogFooter>
          <Button type="button" variant="outline" onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            type="button"
            disabled={!message.trim() || sendMessage.isPending}
            onClick={() => lab && sendMessage.mutate({ id: lab.id, message: message.trim() })}
          >
            {sendMessage.isPending ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <Send className="h-4 w-4" />
            )}
            Enviar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
